"use client";

import {useOrg} from "@/hooks/useOrg";
import {apiLive} from "@/lib/api";
import {createSharedApprovalLookup} from "./createSharedApprovalLookup";

const useDefault = createSharedApprovalLookup(async (_orgId: string) => {
   const rules = await apiLive<{defaultScriptId?: string}>("/api/inbound-rules");
   if (rules === null) throw new Error("Failed to load inbound rules");
   return rules.defaultScriptId;
});

export function useDefaultInboundScript(enabled: boolean) {
   const {org} = useOrg();
   return useDefault(enabled && org?.id ? org.id : null);
}
